import type { RoleLite } from '@blauturquesa/shared/roles-lite';

/** Pantalla d'inici de cada perfil (§10.4). */
export function startPathFor(activeRole: RoleLite | null): string {
  return activeRole === 'agent' || activeRole === 'superadmin' ? '/avui' : '/explora';
}

/**
 * Canvia el perfil actiu (§2.2): la Function canvia el claim, es força un token nou i es recarrega
 * l'app (a l'inici del perfil nou, o a `stayAt`), perquè no quedi cap dada del perfil anterior en pantalla.
 */
export async function switchProfile(role: RoleLite, stayAt?: string): Promise<void> {
  const [{ call }, { auth }] = await Promise.all([import('../../firebase/functions'), import('../../firebase/auth')]);
  await call<{ role: RoleLite }, { activeRole: RoleLite }>('switchProfile', { role });
  await auth.currentUser?.getIdToken(true);
  window.location.assign(stayAt ?? startPathFor(role));
}

/**
 * Tancament de sessió segur (§15): la memòria cau local de Firestore no la protegeixen les regles,
 * així que s'esborra i es recarrega la pàgina.
 */
export async function signOutCompletely(): Promise<void> {
  const [{ auth }, { signOut }, { db }, { clearIndexedDbPersistence, terminate }] = await Promise.all([
    import('../../firebase/auth'),
    import('firebase/auth'),
    import('../../firebase/firestore'),
    import('firebase/firestore'),
  ]);
  await signOut(auth);
  await terminate(db);
  try {
    await clearIndexedDbPersistence(db);
  } finally {
    window.location.assign('/');
  }
}

/**
 * Recarrega l'app sense haver-la de tancar (petició de l'usuari): útil sobretot amb la PWA instal·lada,
 * que no té el botó del navegador. L'`index.html` es serveix sense memòria cau (§20.4), i per tant
 * es baixa la versió publicada més nova.
 */
export function reloadApp(): void {
  window.location.reload();
}
